<template>
    <div class="d-flex gap-2 mt-2 flex-wrap">


        <div class="box-stats">
            <div class="box-stats-value box-stats-value-en_course">{{ statistiques.nb_attendu }}</div>
            <div class="box-stats-title">Attendus</div>
        </div>
        <div class="box-stats">
            <div class="box-stats-value box-stats-value-arrives">{{ statistiques.nb_passe }}</div>
            <div class="box-stats-title">Passés</div>
        </div>
        <div class="box-stats">
            <div class="box-stats-value box-stats-value-partis">{{ statistiques.nb_coming }}</div>
            <div class="box-stats-title">A venir</div>
        </div>
        <div class="box-stats">
            <div class="box-stats-value box-stats-value-disqualifies">{{ statistiques.nb_retard }}</div>
            <div class="box-stats-title">En retard</div>
        </div>

    </div>
</template>

<script>


export default {
    props: ['parcours'],
    computed: {
        statistiques() {
            let statistiques = {
                nb_attendu: 0,
                nb_passe: 0,
                nb_coming: 0,
                nb_retard: 0,
                nb_skipped: 0,
            }

            for (let i = 0; i < this.parcours.length; i++) {
                const parcours = this.parcours[i];

                statistiques.nb_attendu += parcours.statistique.nb_attendu;
                statistiques.nb_passe += parcours.statistique.nb_passe;
                statistiques.nb_coming += parcours.remaining_by_timestamp.length;
                statistiques.nb_retard += parcours.remaining_late_by_timestamp.length + parcours.remaining_very_late_by_timestamp.length;
                statistiques.nb_skipped += parcours.skipped.length;
            }
            return statistiques;
        }
    }

}
</script>

<style lang="scss" scoped>
.box-stats {
    background-color: white;
    font-weight: bold;
    padding: 10px;
    border-radius: 5px;
    min-width: 100px;
    border: 1px solid #dbe0e6;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.box-stats-value {
    font-size: 1.2rem;
}

.box-stats-value-inscrits {
    color: #bd7101;
}

.box-stats-value-partis {
    color: #0143bd;
}

.box-stats-value-en_course {
    color: #babd01;
}

.box-stats-value-arrives {
    color: #037403;
}

.box-stats-value-abandons {
    color: #790101;
}

.box-stats-value-disqualifies {
    color: #790101;
}
</style>